import React, { useMemo, useState } from 'react';
import { Form, Input, Button, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import RRuleBuilderModal from './RRuleBuilderModal';
import { describeRRule } from './rruleUtils';

const { Text } = Typography;

/**
 * Ô "Kiểu lặp" (loop_info): vẫn cho gõ tay chuỗi RRULE như CMS cũ, nhưng nút Create
 * mở modal dựng chuỗi ngay trong CMS4 thay vì nhảy sang cms.lichviet.org.
 *
 * Dòng mô tả bên dưới thay cho {{loopInfo}} (rule.toText()) của CMS cũ.
 * Component phải nằm trong <Form> để useWatch đọc được start_time làm mốc xem trước.
 */
const LoopInfoField = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const startTime = Form.useWatch('start_time');

  const description = useMemo(() => describeRRule(value), [value]);

  return (
    <>
      <Space.Compact className="w-full">
        <Input value={value} onChange={onChange} placeholder="VD: FREQ=YEARLY;INTERVAL=1" allowClear />
        <Button onClick={() => setOpen(true)}>Create</Button>
      </Space.Compact>
      {description && (
        <Text type="secondary" className="block mt-1 text-xs">
          {description}
        </Text>
      )}
      <RRuleBuilderModal
        open={open}
        value={value}
        dtstart={startTime}
        onCancel={() => setOpen(false)}
        onOk={(next) => {
          onChange(next);
          setOpen(false);
        }}
      />
    </>
  );
};

LoopInfoField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default LoopInfoField;
